import { render, staticRenderFns } from "./SectionPracticeDesktop.vue?vue&type=template&id=5ca0d244&scoped=true&"
import script from "./SectionPracticeDesktop.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SectionPracticeDesktop.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SectionPracticeDesktop.vue?vue&type=style&index=0&id=5ca0d244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0d244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca0d244')) {
      api.createRecord('5ca0d244', component.options)
    } else {
      api.reload('5ca0d244', component.options)
    }
    module.hot.accept("./SectionPracticeDesktop.vue?vue&type=template&id=5ca0d244&scoped=true&", function () {
      api.rerender('5ca0d244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/SectionPracticeDesktop.vue"
export default component.exports